import Link from "next/link";
import { cn } from "@/src/lib/utils";
import { Text } from "@/src/components/ui/Typography";

interface NavItemProps {
  href: string;
  children: React.ReactNode;
  active?: boolean;
  dark?: boolean;
}

export function NavItem({ href, children, active, dark }: NavItemProps) {
  return (
    <Link href={href} className="group relative inline-flex items-center">
      <Text
        as="span"
        size="bodySMMedium"
        className={cn(
          "transition-colors duration-300",
          active
            ? "text-brand"
            : dark
              ? "text-neutral-50 group-hover:text-brand font-light"
              : "text-neutral-700 group-hover:text-brand font-light",
        )}
      >
        {children}
      </Text>
    </Link>
  );
}
